import cx from 'classix'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React, { useEffect, useMemo } from 'react'

import Container from '@components/common/layout/Container'

import MegaMenuFooter from './MegaMenuFooter'

type Props = {
  open: boolean
  children?: React.ReactNode
  className?: string
  forceFullHeight?: boolean
}

export default function MegaMenu({ open, children, className, forceFullHeight = false }: Props) {
  const breakpoints = useBreakpoint()

  const shouldOpenFully = useMemo(() => open && (!breakpoints.lg3 || forceFullHeight), [
    open,
    breakpoints,
    forceFullHeight,
  ])

  useEffect(() => {
    if (shouldOpenFully) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [shouldOpenFully])

  return (
    <div
      className={cx(
        'inset-x-0 text-white flex-col',
        open ? 'z-10 flex' : 'z-0 hidden',
        shouldOpenFully ? 'bottom-0 fixed' : 'absolute bottom-auto'
      )}
      style={{ top: '68px' }}
    >
      <div className='bg-revamp-red-600 flex flex-1 overflow-hidden'>
        <Container className={cx('py-6 lg3:py-8 xl3:py-12 flex flex-row', className)}>
          {children}
        </Container>
      </div>
      <MegaMenuFooter />
    </div>
  )
}
